import { createReducer, on } from '@ngrx/store';
// Actions
import { addComparisonSecurity, removeComparisonSecurity, resetComparisonSecurities, resetPrimarySecurity, resetSecondarySecurity, setComparisonSecurities, setPrimarySecurity, setSecondarySecurity, } from './report-securities.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
export const primarySecurity = createReducer({ securityId: null, securityName: null }, on(setPrimarySecurity, (state, action) => {
    return {
        securityId: action.securityId,
        securityName: action.securityName,
        displaySecurityID: action.displaySecurityID,
        securityType: action.securityType,
        customLabel: action.customLabel,
        securityListGroup: action.securityListGroup,
    };
}), on(resetPrimarySecurity, resetAllCustomPdfReportItems, () => {
    return { securityId: null, securityName: null, displaySecurityID: null, securityType: null };
}));
export const secondarySecurity = createReducer({ securityId: null, securityName: null }, on(setSecondarySecurity, (state, action) => {
    return {
        securityId: action.securityId,
        securityName: action.securityName,
        displaySecurityID: action.displaySecurityID,
        securityType: action.securityType,
        customLabel: action.customLabel,
    };
}), on(resetSecondarySecurity, resetAllCustomPdfReportItems, () => {
    return { securityId: null, securityName: null, displaySecurityID: null, securityType: null };
}));
export const comparisonSecurities = createReducer([], on(setComparisonSecurities, (state, action) => {
    return action.comparisonSecurities;
}), on(addComparisonSecurity, (state, action) => {
    if (state.some((security) => security.securityId === action.securityId)) {
        return state;
    }
    const { securityId, securityName, displaySecurityID, securityType, customLabel } = action;
    return [...state, { securityId, securityName, displaySecurityID, securityType, customLabel }];
}), on(removeComparisonSecurity, (state, action) => {
    const newState = [...state];
    newState.splice(action.index, 1);
    return newState;
}), on(resetComparisonSecurities, resetAllCustomPdfReportItems, () => []));
